import React from 'react';
import Collapse from '.';
import { createRendererWithUniDriver } from '../utils/test-utils/react';
import { collapsePrivateDriverFactory } from './test/Collapse.private.uni.driver';

describe('Collapse', () => {
  const render = createRendererWithUniDriver(collapsePrivateDriverFactory);

  it('should render', async () => {
    const { driver } = render(<Collapse />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render children', () => {
    const { container } = render(<Collapse children="hello" />);
    expect(container.textContent).toEqual('hello');
  });

  describe('`open` prop', () => {
    it('should not render children when false', () => {
      const { container } = render(<Collapse open={false} children="hello" />);
      expect(container.textContent).toEqual('');
    });

    it('should be reported as false by testkit`s isOpen() when false', async () => {
      const { driver } = render(<Collapse open={false} children="hello" />);
      expect(await driver.isOpen()).toEqual(false);
    });

    it('should be reported as true by testkit`s isOpen() when true', async () => {
      const { driver } = render(<Collapse open children="hello" />);
      expect(await driver.isOpen()).toEqual(true);
    });
  });

  describe('`dataHook` prop', () => {
    it('should be passed to children', () => {
      const hookForRoot = "I'm Hooked!";
      const hookOfChild = 'Leave britney alone!';

      const { container } = render(
        <Collapse
          dataHook={hookForRoot}
          children={<div data-hook={hookOfChild}>arbitrary content</div>}
        />,
      );

      expect(!!container.querySelector(`[data-hook="${hookOfChild}"]`)).toBe(
        true,
      );
    });
  });
});
